import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'
import { slugify } from '@open-tender/utils'
import {
  selectBrand,
  selectCurrentVendor,
  selectDisplaySettings,
  selectMenu,
  selectMenuSlug,
  useAppSelector,
} from '@open-tender/cloud'
import { Content, Main, PageHero, ScreenreaderTitle } from 'components'
import { MenuHeader, MenuCategory } from '../Menu'
import CategoryNav from '../Category/CategoryNav'
import VendorInfo from './VendorInfo'

const VendorView = styled.div``

const VendorHero = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: ${(props) => props.theme.layout.paddingMobile};
  }
`

const Vendor = () => {
  const navigate = useNavigate()
  const { title: siteTitle } = useAppSelector(selectBrand) || {}
  const menuSlug = useAppSelector(selectMenuSlug)
  const { categories = [] } = useAppSelector(selectMenu) || {}
  const displaySettings = useAppSelector(selectDisplaySettings)
  const { menuHeroChild = true, menuHeroChildMobile = true } =
    displaySettings || {}
  const showHero =
    menuHeroChild === undefined
      ? true
      : isMobile
      ? menuHeroChildMobile
      : menuHeroChild
  const vendor = useAppSelector(selectCurrentVendor)
  const { revenue_center_id: id, name, large_image_url } = vendor || {}
  const imageUrl = showHero ? large_image_url : undefined
  const heroHeight = isMobile ? 'auto' : '36rem'
  const vendorCategories = categories.filter((i) => i.revenue_center_id === id)
  const navItems = vendorCategories.map(({ name }) => name)
  const vendorCategory = { name, description: null, items: [] }

  useEffect(() => {
    if (!vendor) navigate(menuSlug)
  }, [vendor, navigate, menuSlug])

  if (!vendor) return null

  return (
    <>
      <Helmet>
        <title>
          Menu - {name} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <MenuHeader />
        <Main>
          <ScreenreaderTitle>{name}</ScreenreaderTitle>
          <PageHero height={heroHeight} imageUrl={imageUrl}>
            <VendorHero>
              <VendorInfo vendor={vendor} />
            </VendorHero>
          </PageHero>
          {navItems.length > 0 ? <CategoryNav items={navItems} /> : <></>}
          <VendorView>
            {!imageUrl ? <MenuCategory category={vendorCategory} /> : null}
            {vendorCategories.map((cat) => (
              <div key={cat.id} id={slugify(cat.name)}>
                <MenuCategory category={cat} />
                {cat.children.map((child) => (
                  <MenuCategory
                    key={child.id}
                    category={child}
                    isChild={true}
                  />
                ))}
              </div>
            ))}
          </VendorView>
        </Main>
      </Content>
    </>
  )
}

export default Vendor
